jQuery(function() {
  if ((window.queries) && (window.queries.highlight != null)) {
    return $(`#${window.queries.highlight}`).toggleClass('bg-success');
  }
});
